import styled from 'styled-components';
import { BLACK, TEAL } from '../../theme';

export const NavFooterContainer = styled.div`
  background: #E8F7F8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.9rem 1.5rem 0.9rem 1.5rem;
  border-top: solid 1px #E1E8E9;
  border-bottom: solid 5px ${TEAL};

  @media (max-height: 35.625rem) {
    display: none;
  }
`;

export const SubscribeText = styled.p`
  font-size: 1rem;
  color: ${BLACK};
  font-family: "PT Sans";
  text-align: center;
  margin-top: 5px;
`;

export const InputContainer = styled.div`
  margin: 0.625rem 0;
  width: 85%;
  box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
  border-radius: 1.25rem;
  display: flex;
  align-items: center;

  @media (max-width: 31.25rem) {
    border-radius: 1rem;
    margin: 0;
  }
`;

export const SocialContainer = styled.div`
  width: 15rem;
  display: flex;
  justify-content: space-evenly;
  margin: 0.625rem 0;
`;
